import Masonry from 'masonry-layout/masonry.js'
import imagesLoaded from 'imagesloaded/imagesloaded.js'

document.addEventListener("DOMContentLoaded", function(event) {
    // console.log("DOM fully loaded and parsed");

    // set block gallery selector
    let elem = document.querySelector('.wp-block-gallery');

    // init Masonry
    let msnry = new Masonry( elem, {
        // options
        itemSelector: '.blocks-gallery-item',
        columnWidth: '.blocks-gallery-item',
        percentPosition: true
    });

    imagesLoaded( elem, function( instance ) {
        // console.log('all images are loaded');
        msnry.layout();
    });

    $(elem).on('resizeme.zf.trigger', () => {
        msnry.layout();
    });
});
